import React from 'react'

export type CircleProps = {
  fill: string
  width?: number
  height?: number
}
export const Circle: React.FC<CircleProps> = ({ fill, width = 10, height = 10 }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 10 10' fill='none'>
      <circle cx='5' cy='5' r='5' fill={fill} />
    </svg>
  )
}
